import { Box, IconButton, styled } from '@mui/material';
import { NavLink } from 'react-router-dom';

import { AlertProps } from '.';

export const NavLinkW = styled(NavLink)`
  display: block;
  margin-top: 4px;
  text-decoration: underline;
  font-size: 14px;
  font-weight: 400;
`;

export const AlertContentW = styled(Box)`
  max-width: 90%;
`;

export const AlertW = styled(Box)<Pick<AlertProps, 'variant'>>`
  display: flex;
  align-items: center;
  margin-left: 76px;
  color: ${({ theme }) => theme.palette.overlay};
  border-radius: 12px;
  width: 400px;
  padding: 16px;
  background-color: ${({ theme }) => theme.palette.white.main};
  box-shadow: ${({ theme }) => `0px 4px 20px ${theme.palette.primary.p010}`};
  gap: 12px;

  @media (max-width: 1023px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const AlertContent = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const AlertIconW = styled(Box)`
  display: flex;
  align-items: center;

  svg {
    height: 40px;
    width: 40px;
  }
`;

export const AlertMessage = styled(Box)`
  font-size: 16px;
  font-weight: 600;
  max-width: 100%;
`;

export const CloseButton = styled(IconButton)`
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
  padding: 10px;
  display: flex;
  align-items: center;
`;
